import React from 'react';
import classnames from 'classnames';
import { Popover as AntdPopover, PopoverProps } from 'antd';

import './style.scss';

const PREFIX = 'music';

const defaultGetPopupContainer = (triggerNode: HTMLElement) => triggerNode.parentNode as HTMLElement;

export default function Popover(props: PopoverProps) {
  const {
    overlayClassName,
    getPopupContainer = defaultGetPopupContainer,
    ...rstProps
  } = props;

  return (
    <AntdPopover
      overlayClassName={classnames(`${PREFIX}-popover`, overlayClassName)}
      getPopupContainer={getPopupContainer}
      {...rstProps}
    />
  );
}
